module.exports = __webpack_public_path__ + "static/img/14000588.f795ba0e.png";